import React, { useCallback } from 'react';
import classNames from 'classnames';
import { Clickable } from '@moda/om';
import './VerticalSnapperSteps.scss';

type VerticalSnapperStepsProps = Omit<React.HTMLAttributes<HTMLDivElement>, 'onClick'> & {
  length: number;
  index: number;
  onClick?(step: number): void;
};

export const VerticalSnapperSteps: React.FC<VerticalSnapperStepsProps> = ({
  length = 1,
  index = 1,
  onClick,
  className
}) => {
  const handleClick = useCallback(
    (step: number) => () => {
      onClick?.(step);
    },
    [onClick]
  );

  return (
    <div className={classNames('VerticalSnapperSteps', className)}>
      {Array(...Array(length)).map((_, step) => (
        <Clickable
          key={step}
          className={classNames('VerticalSnapperSteps__step', {
            'VerticalSnapperSteps__step--active': index === step
          })}
          onClick={handleClick(step)}
        />
      ))}
    </div>
  );
};
